import { useMemo } from "react";
import Cookies from "js-cookie";
import { CURRENCY_CONFIG, DEFAULT_CURRENCY } from "../config/currency";
import { useTranslation } from "react-i18next";

/**
 * Custom hook for currency formatting and country detection
 * @param {string} country - Optional country override (from props)
 * @returns {Object} Currency information and formatting function
 */
export const useCurrencyFormatter = (country = null) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const currencyInfo = useMemo(() => {
        // Use provided country or get from cookies
        const cookie = Cookies.get();
        const userLocation = country || cookie["X-countryName"];

        if (!userLocation) {
            return DEFAULT_CURRENCY;
        }

        const locationKey = userLocation.toLowerCase();
        return CURRENCY_CONFIG[locationKey] || DEFAULT_CURRENCY;
    }, [country]);

    /**
     * Format price with locale-specific formatting based on current language
     * @param {number|string} price - Price to format
     * @returns {string} Formatted price string
     */
    const formatPrice = (price) => {
        if (!price) return "0";
        // Use the current language from i18n for number formatting
        return parseFloat(price).toLocaleString(currentLang);
    };

    return {
        currency: currencyInfo.symbol,
        countryFlag: currencyInfo.flag,
        formatPrice,
    };
};
